import React from "react";
import Loader from "components/Loader/Loader";

/**
 * Get the appropriate suspense fallback based on current path
 * @returns {React.Element|null} The fallback component or null
 */
const getSuspenseFallback = (() => {
	const currentPath = window.location.pathname;

	const isNotCompleteProfilePath =
		currentPath === "/client/seller/complete-profile";
	const isDepotConnect = currentPath.includes("depot-connect");

	const shouldShowLoader = isNotCompleteProfilePath || isDepotConnect;

	return shouldShowLoader ? null : <Loader />;
})();

export default getSuspenseFallback;
